import type { FaireProductEntity } from "../../entity_types/product";

export const p_wy3mubbrev: FaireProductEntity = {
  token: "p_wy3mubbrev",
  type: "product",
  name: "Black Flame Soy Candle - Halloween Collection",
  brandToken: "b_yynur8ww",
  brandName: "Good & Well Supply Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/8da91e50a3e5f523716bc64e5d32753ca9a033bc0c3fe9567415f9f38892e736.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0445bfbacff91904cbb00ea0275353dada183303dd84ffbc66f9b0a76debc0e1.png",
    "https://cdn.faire.com/fastly/9bed303591d543dad7fc60c143bce0dbdc719d90e8ebde90b7de730236942e66.png",
  ],
  priceDollars: 13,
  description:
    "Notes of incense, oud & leather\n\nIt’s spooky season — and our limited-edition halloween candles are ready to set the mood. From eerie embers to sweet tricks and sticky treats, this collection is full of wicked woods, spellbinding spice, and just enough mischief.\n\nAvailable in 8oz size with cotton wick only.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:40.524Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
